<div class="waves">
    <div class="wave wave-short"></div>
    <div class="wave wave-long"></div>
    <div class="wave wave-short"></div>
    <div class="wave wave-long"></div>
    <div class="wave wave-short"></div>
</div>